export default __webpack_public_path__ + "static/media/Desiree.9082c597.jpg";